import config from '../../config';
import API from '../api';

const { baseUrl } = config.coreApi;

const getCampaigns = async (cid, page = '', filter = '', pageSize = 200, orderBy = 'displayName, id') => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/companies/${cid}/campaigns?pageSize=${pageSize}&pageToken=${page}&filter=${filter}&orderBy=${orderBy}`;

  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    method: 'GET'
  }).then(res => API.generateResponse(res));
};

const createCampaign = async (cid, campaignObject) => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/companies/${cid}/campaigns`;

  return fetch(url, {
    method: 'POST',
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    body: JSON.stringify(campaignObject)
  }).then(res => res.json());
};

const getCampaignById = async caid => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/companies/-/campaigns/${caid}`;

  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    method: 'GET'
  }).then(res => API.generateResponse(res));
};

const deleteCampaign = async (cid, caid) => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/companies/${cid}/campaigns/${caid}`;

  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    method: 'DELETE'
  }).then(res => API.generateResponse(res));
};

const updateCampaign = async (cid, caid, campaign, fields) => {
  await API.refreshTokenWhenNeeded();

  const paths = `updateMask=${fields.join(',')}`;
  const body = {};

  fields.forEach(field => {
    body[field] = campaign[field];
  });

  const url = `${baseUrl}/companies/${cid}/campaigns/${caid}?${paths}`;

  return fetch(url, {
    method: 'PATCH',
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    body: JSON.stringify(body)
  }).then(res => API.generateResponse(res));
};

const assignSitesToCampaign = async (cid, caid, siteIds) => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/companies/${cid}/campaigns/${caid}:assignSites`;
  const body = { siteIds };

  return fetch(url, {
    method: 'POST',
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    body: JSON.stringify(body)
  }).then(res => API.generateResponse(res));
};

const unassignSitesFromCampaign = async (cid, caid, siteIds) => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/companies/${cid}/campaigns/${caid}:unassignSites`;
  const body = { siteIds };
  return fetch(url, {
    method: 'POST',
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    body: JSON.stringify(body)
  }).then(res => API.generateResponse(res));
};

const inviteUsersToCampaign = async (caid, userObject) => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/companies/-/campaigns/${caid}:inviteUsers`;

  return fetch(url, {
    method: 'POST',
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    body: JSON.stringify(userObject)
  }).then(res => API.generateResponse(res));
};

export {
  getCampaigns,
  createCampaign,
  getCampaignById,
  deleteCampaign,
  updateCampaign,
  assignSitesToCampaign,
  unassignSitesFromCampaign,
  inviteUsersToCampaign
};
